import type { CommentReadStatus, ReportComment } from '@/types/report';

export type ReportCommentSummaryStatus = 'NONE' | 'UNREAD' | 'READ';

export interface ReportCommentSummary {
  status: ReportCommentSummaryStatus;
  label: string;
  tagColor: 'default' | 'blue' | 'green';
}

export function summarizeReportComments(
  comments: ReportComment[],
  employeeId: string,
): ReportCommentSummary {
  const received = comments.filter((comment) => comment.receiverId === employeeId);

  if (received.length === 0) {
    return { status: 'NONE', label: '无点评', tagColor: 'default' };
  }

  if (received.some((comment) => comment.readStatus === 'UNREAD')) {
    return { status: 'UNREAD', label: '未读', tagColor: 'blue' };
  }

  return { status: 'READ', label: '已读', tagColor: 'green' };
}

export const COMMENT_READ_STATUS_LABELS: Record<CommentReadStatus, string> = {
  UNREAD: '未读',
  READ: '已读',
};
